class CustomDropdown {
  constructor() {
    this.dropdownButton = document.querySelector(".js-custom-dropwdown");

    if (this.dropdownButton) {
      document.addEventListener("click", (event) => {
        const clickedButton = event.target.closest(
          ".js-custom-dropwdown-button"
        );
        if (clickedButton) {
          this.dropdownButton.classList.toggle("active");
        } else {
          this.dropdownButton.classList.remove("active");
        }
      });
    }
  }
}

export default new CustomDropdown();
